/**
 * Convert between formats, such as Markdown to HTML or HTML to Markdown.
 */

import TurndownService from 'turndown'
import { tables, strikethrough } from 'turndown-plugin-gfm'
import showdown from 'showdown'

export function htmlToMarkdown(html) {
  let turndownService = new TurndownService({
    headingStyle: 'atx',
    codeBlockStyle: 'fenced',
    hr: '---'
  })

  turndownService.use([tables, strikethrough])

  return turndownService.turndown(html)
}

export function markdownToHTML(markdown) {
  const converter = new showdown.Converter()
  return converter.makeHtml(markdown)
}
